import { getVehiclePlateOptionsApi } from 'api/fleet-tires-replacements';
import type { ID } from 'common/types';
import type { HeaderItem } from 'components/data-table';
import type { ReactNode } from 'react';

export interface FleetReplacementsTable {
  id: ID;
  vehicle_plate: string;
  vehicle_brand_model: string;
  tire_model: string;
  season: string;
  size: string;
  diameter: string;
  status: string;
  defect: ReactNode;
  tread_depth: ReactNode;
  replacement_confirmation: ReactNode;
  tire_storage: ReactNode;
  fact_tire_storage: ReactNode;
  paid_storage: string;
  action: ReactNode;
  recipient_data: ReactNode;
  confirmed: ReactNode;
  confirmed_at: string;
}

export const tableHeaders: HeaderItem<FleetReplacementsTable>[] = [
  {
    id: 'vehicle_plate',
    title: 'ДНЗ',
    width: '100px',
    filter: { fetcher: getVehiclePlateOptionsApi, searchKey: 'search_plate' }
  },
  {
    id: 'vehicle_brand_model',
    title: 'Марка/ модель',
    width: '150px'
  },
  { id: 'tire_model', title: 'Модель шин', width: '154px' },
  { id: 'season', title: 'Сезон', width: '79px' },
  { id: 'size', title: 'Розмір', width: '86px' },
  { id: 'diameter', title: 'Діаметр', width: '93px' },
  { id: 'status', title: 'Статус шин', width: '170px' },
  { id: 'defect', title: 'Опис брака', width: '125px' },
  { id: 'tread_depth', title: 'Глибина протектора', width: '124px' },
  {
    id: 'replacement_confirmation',
    title: 'Підтвердження заміни',
    width: '150px',
    editable: true,
    booleanFilter: 'need_replacement'
  },
  {
    id: 'fact_tire_storage',
    title: 'Фактичне місце зберігання шин',
    width: '240px'
  },
  {
    id: 'tire_storage',
    title: 'Перемістити на склад',
    width: '215px',
    editable: true
  },
  { id: 'paid_storage', title: 'платне зберігання', width: '115px' },
  { id: 'action', title: 'Рішення по шині', width: '153px', editable: true },
  {
    id: 'recipient_data',
    title: 'ПІБ, телефон, адреса отримувача',
    width: '209px',
    editable: true
  },
  { id: 'confirmed', title: 'Підтвердження', width: '147px', editable: true },
  { id: 'confirmed_at', title: 'дата підтвердження', width: '151px' }
];
